// extracted by mini-css-extract-plugin
export default {"cursor":"Cursor_cursor__98OV1","cursor-right":"Cursor_cursor-right__WQBZX"};